import PassengerCondition from "./PassengerCondition";

const passengerConditionChoices = [
    { id: PassengerCondition.RESIDENT, name: "passenger.condition.resident" },
    { id: PassengerCondition.DOMESTIC, name: "passenger.condition.domestic" },
    { id: PassengerCondition.FOREIGN, name: "passenger.condition.foreign" },
];

export default passengerConditionChoices;
